import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { WorkOrdersService } from '../../work-orders.service';

@Component({
  selector: 'work-order-copy-dialog',
  templateUrl: './work-order-copy-dialog.component.html',
  styleUrls: ['./work-order-copy-dialog.component.scss']
})
export class WorkOrderCopyDialogComponent implements OnInit {
  options: any = {};
  selectedOption: any;
  workOrderService: any;

  constructor(
    public dialogRef: MatDialogRef<WorkOrderCopyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    injector: Injector) {
    this.options = data;
    this.workOrderService = injector.get(WorkOrdersService);
  }

  onYesClick(): any {
    this.dialogRef.close(this.selectedOption);
  }

  changeHandler(event: any) {
    this.selectedOption = event.target.value;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isDisabled() {
    if (this.selectedOption) {
      return false;
    }
    return true;
  }

  ngOnInit() {
    //this is kept empty on purpose
  }

}
